
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import AsyncSelect from 'react-select/async';

function StockItemReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };


    // Item

    const [ItemTypeOptions, setItemTypeOptions] = useState([]);
    const [selectedItemType, setSelectedItemType] = useState("");
    const [selectedItem, setSelectedItem] = useState("0");

    const fetchItemType = async () => {
        try {

            const response = await fetchData('ItemApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(itm => ({
                    value: itm.id,
                    label: itm.name
                }));
                setItemTypeOptions(options);
            }

        } catch (error) {
            console.error('Error fetching  Item Type:', error);
        }
    };
    const handleItemTypeChange = (selectedOption) => {
        setSelectedItemType(selectedOption);
        setSelectedItem(selectedOption.value);
    };

    useEffect(() => {
        fetchItemType();
    }, []);



    const fetchTableData = async () => {
        const branchId = 0;
        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/StcokItemWise/${companyId}/${branchId}/${selectedItem}/${fromDate}/${toDate}/`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Stock Raw Material Details:', error);
        }

    };



    const hasReadReportPermission = permissions.includes('Read Reports');


    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };


    // const handleExportExcel = () => {
    //     const excelData = [];
    //     const headerCaption = [`Stock Item Data`];
    //     excelData.push(headerCaption);
    //     const headerRow = ['Code', 'Name', 'HSNCode', 'GSTRate', 'Opening Qty', 'Sale Qty', 'Sale Return Qty', 'Purchase Qty', 'Purchase Return Qty', 'Stock Journal Qty', 'Closing Qty'];
    //     excelData.push(headerRow);
    //     filteredDataItem.forEach((rowData, index) => {
    //         const dataRow = [];
    //         dataRow.push(rowData.Code, rowData.Name, rowData.HSNCode, rowData.GSTRate, rowData.OpeningQty, rowData.SaleQty, rowData.SaleReturnQty, rowData.PurchaseQty, rowData.PurchaseReturnQty, rowData.StockJournalQty, rowData.ClosingQty);
    //         excelData.push(dataRow);
    //     });

    //     const ws = XLSX.utils.aoa_to_sheet(excelData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Stock Item Details');
    //     XLSX.writeFile(wb, 'Stock_Item_Details.xlsx');
    // };

    const handleExportExcel = () => {
        const excelData = [];
        const headerCaption = ['Stock Raw Material Data'];
        excelData.push(headerCaption);

        const headerRow = ['Code', 'Name', 'HSNCode', 'GSTRate', 'Opening Qty', 'Production Qty', 'Sale Qty', 'Sale Return Qty', 'Closing Qty'];
        excelData.push(headerRow);

        // Initialize totals
        let totalOpeningQty = 0;
        let totalPurchaseQty = 0;
        let totalPurchaseReturnQty = 0;
        let totalSaleQty = 0;
        let totalSaleRtnQty = 0;
        let totalClosingQty = 0;

        // Data rows
        filteredDataItem.forEach(rowData => {
            const dataRow = [
                rowData.Code,
                rowData.Name,
                rowData.HSNCode,
                rowData.GSTRate,
                rowData.OpeningQty,
                rowData.PurchaseQty,               
                rowData.SaleQty,
                rowData.SaleReturnQty,
                rowData.ClosingQty
            ];

            // Add to totals
            totalOpeningQty += Number(rowData.OpeningQty || 0);
            totalPurchaseQty += Number(rowData.PurchaseQty || 0);
            totalPurchaseReturnQty += Number(rowData.PurchaseReturnQty || 0);
            totalSaleQty += Number(rowData.SaleQty || 0);
            totalSaleRtnQty += Number(rowData.SaleReturnQty || 0);
            totalClosingQty += Number(rowData.ClosingQty || 0);

            excelData.push(dataRow);
        });

        // Total row
        const totalRow = [
            'Total', '', '', '', // placeholders for non-numeric columns
            totalOpeningQty,
            totalPurchaseQty,           
            totalSaleQty,
            totalSaleRtnQty,
            totalClosingQty
        ];
        excelData.push(totalRow);

        // Create sheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Merge title row
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: headerRow.length - 1 } },
        ];

        // Column widths
        ws['!cols'] = headerRow.map(() => ({ wch: 20 }));

        // Workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Stock Item Details');
        XLSX.writeFile(wb, 'Stock_Item_Details.xlsx');
    };

    const cellStyle = {
        borderBottom: '1px solid black',
        color: 'black',
        fontWeight: 'bolder',
        padding: '7px',
        fontSize: '12px',
    };


    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <h6
                className="uppercase tracking-wide text-black font-serif flex-grow"
                style={{
                    fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                    color: 'black',
                    marginTop: '10px',
                }}
            >
                Stock - Item Wise Report
            </h6>

            <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '2px', marginTop: '1.25%' }}>

                <div style={{ maxWidth: '150px', marginRight: '10px' }}>
                    <label
                        className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                        htmlFor="fromDate"
                    >
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date"
                        value={fromDate}
                        onChange={handleFromDateChange}
                    />
                </div>
                <div style={{ maxWidth: '150px', marginRight: '10px' }}>
                    <label
                        className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                        htmlFor="toDate"
                    >
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date"
                        value={toDate}
                        onChange={handleToDateChange}
                    />
                </div>
                <div className="w-1/2 mr-2">

                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                        Item
                    </label>

                    <Select
                        value={selectedItemType}
                        onChange={handleItemTypeChange}
                        options={ItemTypeOptions}
                        placeholder="Item"
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                            }),
                            control: (provided) => ({
                                ...provided,
                                //width: '350px',
                            }),
                        }}
                        isSearchable
                    />

                </div>

                <Button
                    // style={{ marginLeft: '8px', color: 'darkgreen' }}
                    style={{
                        background: 'linear-gradient(to right, #A8A196,#A8A196)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        //marginLeft: '5px',
                        marginLeft: '15px',
                        marginTop: '1.5%'

                    }}
                    onClick={fetchTableData}

                >
                    <RefreshIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Refresh</b>
                </Button>

                <Button
                    // style={{ marginLeft: '8px', color: 'darkgreen' }}
                    style={{
                        background: 'linear-gradient(to right, #4D455D,#4D455D)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        //marginLeft: '5px',
                        marginLeft: '15px',
                        marginTop: '1.5%'

                    }}
                    onClick={handleExportExcel}

                >
                    <FeedIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Excel</b>
                </Button>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '510px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#D8D9CF' }}>
                            <TableRow>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', padding: '4px', fontWeight: 'bold' }}>Code</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', padding: '4px', fontWeight: 'bold' }}>Name</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', padding: '4px', fontWeight: 'bold' }}>HSNCode</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold' }}>GSTRate</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold' }}>Opening Qty</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold' }}>Production Qty</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold' }}>Sale Qty</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold' }}>Sale Return Qty</TableCell>
                                <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold' }}>Closing Qty</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={data.routeName === 'Total' ? 'highlighted-row' : ''}
                                    sx={{
                                        padding: '7px',
                                        height: '40px',
                                        backgroundColor: data.routeName === 'Total' ? 'teal' : 'transparent',
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'left', fontSize: '12px' }}>{data.Code}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'left', fontSize: '12px' }}>{data.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'left', fontSize: '12px' }}>{data.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'right', fontSize: '12px' }}>{data.GSTRate}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'right', fontSize: '12px' }}>{data.OpeningQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'right', fontSize: '12px' }}>{data.PurchaseQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'right', fontSize: '12px' }}>{data.SaleQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'right', fontSize: '12px' }}>{data.SaleReturnQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '7px', textAlign: 'right', fontSize: '12px' }}>{data.ClosingQty}</TableCell>


                                </TableRow>
                            ))}
                            {/* Total Row */}
                            <TableRow sx={{ backgroundColor: '#EDDFE0' }}>
                                <TableCell colSpan={4} sx={{ ...cellStyle, fontWeight: 'bold' }}>TOTAL</TableCell>
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.OpeningQty || 0), 0).toFixed(2)}
                                </TableCell>
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.PurchaseQty || 0), 0).toFixed(2)}
                                </TableCell>                                
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.SaleQty || 0), 0).toFixed(2)}
                                </TableCell>
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.SaleReturnQty || 0), 0).toFixed(2)}
                                </TableCell>
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.ClosingQty || 0), 0).toFixed(2)}
                                </TableCell>

                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
        </div>
    );
}

export default StockItemReport;
